import { Flex, Button, Heading, Divider, useToast } from "@chakra-ui/react";
import SelectComponent from "../../UI/Select";
import { ArrowDownIcon, ArrowUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import TripleChart from "../../UI/TripleChart";
import { useEffect } from "react";
import { useState } from "react";
import Modal from "../../overlay/Modal";
import {
  generateReport,
  getIncome,
  getInvoices,
  getRequisitions,
} from "../../../util/http";
import { filterDate } from "../../../util/lib";
import ReusableText from "../../UI/ReusableText";
import { BsDashLg } from "react-icons/bs";

function monthFilter(data, month) {
  return data?.filter((el) => {
    const createdMonth = new Date(el.created_at).getMonth() + 1;
    return +createdMonth === +month;
  });
}

export default function FinanceReportDetail({ show }) {
  const [days, setDays] = useState(0);
  const [filter, setFilter] = useState("daily");
  const [category, setCategory] = useState("");
  const [income, setIncome] = useState(0);
  const [expected, setExpected] = useState(0);
  const [expenseData, setExpenseData] = useState(0);
  const [actual, setActual] = useState({
    January: 0,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 0,
    December: 0,
  });

  const [projected, setProjected] = useState({
    January: 0,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 0,
    December: 0,
  });

  const [expenses, setExpenses] = useState({
    January: 0,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 0,
    December: 0,
  });
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  async function reportHandler() {
    const taskReport = [
      {
        actualIncome: actual,
        projectedIncome: projected,
        expenses,
      },
    ];

    const data = {
      report: "Clients",
      data: JSON.stringify(taskReport),
    };

    try {
      setLoading(true);
      await generateReport(data);
      toast({
        title: `Finance report generated`,
        description: "",
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast({
        title: `Error`,
        description: `${
          error?.response?.data.message || "something went wrong"
        }`,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  }

  useEffect(() => {
    if (filter?.toLowerCase() === "daily") {
      setDays(1);
    } else if (filter?.toLowerCase() === "weekly") {
      setDays(7);
    } else if (filter?.toLowerCase() === "monthly") {
      setDays(30);
    } else {
      setDays("");
    }
  }, [filter]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getInvoices();

        const invoices = response?.invoices?.filter((el, i) => {
          if (!days) {
            return el.deleted_at === null;
          }
          const milliSec = +days * 24 * 60 * 60 * 1000;
          const startDate = filterDate(milliSec);
          const createdDate = new Date(el?.created_at);
          return startDate < createdDate && el.deleted_at === null;
        });
        if (!category || category?.toLowerCase() === "projected income") {
          setProjected({
            January: monthFilter(invoices, 1)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            February: monthFilter(invoices, 2)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            March: monthFilter(invoices, 3)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            April: monthFilter(invoices, 4)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            May: monthFilter(invoices, 5)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            June: monthFilter(invoices, 6)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            July: monthFilter(invoices, 7)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            August: monthFilter(invoices, 8)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            September: monthFilter(invoices, 9)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            October: monthFilter(invoices, 10)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            November: monthFilter(invoices, 11)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            December: monthFilter(invoices, 12)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
          });
        } else {
          setProjected([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [days, category]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getIncome();
        const receipts = response?.receipts?.filter((el, i) => {
          if (!days) {
            return el.deleted_at === null;
          }
          const milliSec = +days * 24 * 60 * 60 * 1000;
          const startDate = filterDate(milliSec);
          const createdDate = new Date(el?.created_at);
          return startDate < createdDate && el.deleted_at === null;
        });

        if (!category || category?.toLowerCase() === "actual income") {
          setActual({
            January: monthFilter(receipts, 1)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            February: monthFilter(receipts, 2)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            March: monthFilter(receipts, 3)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            April: monthFilter(receipts, 4)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            May: monthFilter(receipts, 5)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            June: monthFilter(receipts, 6)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            July: monthFilter(receipts, 7)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            August: monthFilter(receipts, 8)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            September: monthFilter(receipts, 9)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            October: monthFilter(receipts, 10)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            November: monthFilter(receipts, 11)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            December: monthFilter(receipts, 12)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
          });
        } else {
          setActual([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [days, category]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getRequisitions();
        const receipts = response?.requisitions?.filter((el, i) => {
          if (!days) {
            return el;
          }
          const milliSec = +days * 24 * 60 * 60 * 1000;
          const startDate = filterDate(milliSec);
          const createdDate = new Date(el?.created_at);
          return startDate < createdDate && el.deleted_at === null;
        });
        if (!category || category?.toLowerCase() === "expenses") {
          setExpenses({
            January: monthFilter(receipts, 1)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            February: monthFilter(receipts, 2)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            March: monthFilter(receipts, 3)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            April: monthFilter(receipts, 4)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            May: monthFilter(receipts, 5)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            June: monthFilter(receipts, 6)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            July: monthFilter(receipts, 7)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            August: monthFilter(receipts, 8)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            September: monthFilter(receipts, 9)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            October: monthFilter(receipts, 10)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            November: monthFilter(receipts, 11)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
            December: monthFilter(receipts, 12)
              ?.map((el) => +el.amount)
              ?.reduce((acc, sum) => acc + sum, 0),
          });
        } else {
          setExpenses([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [days, category]);

  function closeModal() {
    show(false);
  }

  useEffect(() => {
    const totalIncomeArr = Object.values(actual);
    const totalIncome = totalIncomeArr?.reduce((acc, sum) => acc + sum, 0);
    setIncome(totalIncome);
  }, [actual]);

  useEffect(() => {
    const expectedIncomeArr = Object.values(projected);
    const expectedIncome = expectedIncomeArr?.reduce(
      (acc, sum) => acc + sum,
      0
    );
    setExpected(expectedIncome);
  }, [projected]);

  useEffect(() => {
    const expensesData = Object.values(expenses);
    const totalExpenses = expensesData?.reduce((acc, sum) => acc + sum, 0);
    setExpenseData(totalExpenses);
  }, [expenses]);

  return (
    <Modal hide={closeModal}>
      <Flex align="start" direction="column" gap="2rem" w="100%">
        <Heading size="md" color="var(--container_color)" fontWeight={600}>
          Finance Report
        </Heading>
        <Divider />
        <Flex w="100%" align="center" justify="space-between">
          <Flex align="center" w="60%" gap="1rem">
            <SelectComponent
              label="Categories"
              onChange={(e) => setCategory(e.value)}
              options={[
                "Select Category",
                "Actual Income",
                "Projected Income",
                "Expenses",
              ]}
            />

            <SelectComponent
              label="Duration"
              onChange={(e) => setFilter(e.value)}
              options={["Daily", "Weekly", "Monthly", "All Time"]}
            />
          </Flex>
          <Button
            variant="solid"
            bg="brand.900"
            color="white"
            rightIcon={<ChevronDownIcon />}
            isLoading={loading}
            loadingText="Generating"
            onClick={reportHandler}
          >
            Generate Report
          </Button>
        </Flex>
        <Flex align="center" gap="2rem">
          <Flex align="center" gap="1rem">
            <Flex
              align="center"
              p="0.8rem"
              bg="rgba(255, 150, 93, 0.3)"
              justify="center"
              borderRadius="16px"
            >
              <ArrowUpIcon color="#FF965D" />
            </Flex>
            <Flex align="start" direction="column">
              <ReusableText
                text={`₦${new Intl.NumberFormat().format(expenseData)}.00`}
                color="var(--container_color)"
                size="16px"
                weight="bold"
              />
              <ReusableText
                text="Total Expenses"
                color="var(--container_color)"
                size="14px"
                weight="light"
              />
            </Flex>
          </Flex>

          <Flex align="center" gap="1rem">
            <Flex
              align="center"
              p="0.8rem"
              bg="rgba(48, 79, 253, 0.3)"
              justify="center"
              borderRadius="16px"
            >
              <BsDashLg color="#304FFD" />
            </Flex>
            <Flex align="start" direction="column">
              <ReusableText
                text={`₦${new Intl.NumberFormat()?.format(expected)}.00`}
                color="var(--container_color)"
                size="16px"
                weight="bold"
              />
              <ReusableText
                text="Expected Income"
                color="var(--container_color)"
                size="14px"
                weight="light"
              />
            </Flex>
          </Flex>

          <Flex align="center" gap="1rem">
            <Flex
              align="center"
              p="0.8rem"
              bg="rgba(73, 201, 109, 0.3)"
              justify="center"
              borderRadius="16px"
            >
              <ArrowDownIcon color="#49C96D" />
            </Flex>
            <Flex align="start" direction="column">
              <ReusableText
                text={`₦${new Intl.NumberFormat().format(income)}.00`}
                color="var(--container_color)"
                size="16px"
                weight="bold"
              />
              <ReusableText
                text="Total Income"
                color="var(--container_color)"
                size="14px"
                weight="light"
              />
            </Flex>
          </Flex>
        </Flex>
        <TripleChart
          projected={Object.values(projected)}
          actual={Object.values(actual)}
          expenses={Object.values(expenses)}
        />
      </Flex>
    </Modal>
  );
}
